import React from 'react'
import PropTypes from 'prop-types'
import { useWillPipe } from '@morningtrain/react-helpers'
import { useOperations, useResource } from '../hooks'
import { Env } from '@morningtrain/helpers'
import { get } from 'lodash'

function RefreshEnvOnPipe (props) {
  const resource = useResource()
  const operations = useOperations()

  const namespace = props.namespace || resource.namespace
  const resourceName = props.resourceName || resource.slug
  const { operationName } = props

  const operation = operations.get(namespace, resourceName, operationName)

  useWillPipe((payload) => {
    return new Promise((resolve, reject) => {
      if (!operation) {
        reject('Attempted to pipe an operation execute, but the requested operation was falsy')
      }

      const dataResolver = (typeof props.data === 'function') ? props.data(payload) : (props.data)

      Promise.resolve(dataResolver).then(data => {
        operation.execute(data)
          .then((data) => {
            if (props.dataPath) {
              data = get(data, props.dataPath)
            }

            const pathResolver = (typeof props.path === 'function') ? props.path(payload) : (props.path)

            Promise.resolve(pathResolver).then(path => {
              Env.set(path, data)
              resolve(payload)
            })
          })
          .catch((err) => {
            reject(err)
          })
      })
    })
  })

  return null
}

RefreshEnvOnPipe.defaultProps = {
  path: null,
  namespace: null,
  resourceName: null,
  operationName: null,
  dataPath: null,
  data: {}
}

RefreshEnvOnPipe.propTypes = {
  path: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  namespace: PropTypes.string,
  resourceName: PropTypes.string,
  operationName: PropTypes.string.isRequired,
  dataPath: PropTypes.string,
  data: PropTypes.object
}

export default RefreshEnvOnPipe
